// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientHistory_root__3jUnc","tooltip":"PatientHistory_tooltip__2BqHc"};